import { createStyles } from '@codeleap/styles'
import { IconComposition } from '@codeleap/web'
import { StyleRegistry } from '../styles'

const createIconVariant = createStyles<IconComposition>

export const IconStyles = {
  default: createIconVariant((theme) => ({
    icon: {
      color: theme.baseColors.neutralSolid1000,
      width: theme.values.iconSize[4],
      height: theme.values.iconSize[4],
    },
  })),
  'size:1': createIconVariant((theme) => ({
    icon: {
      width: theme.values.iconSize[1],
      height: theme.values.iconSize[1],
    },
  })),
  'size:2': createIconVariant((theme) => ({
    icon: {
      width: theme.values.iconSize[2],
      height: theme.values.iconSize[2],
    },
  })),
  'size:3': createIconVariant((theme) => ({
    icon: {
      width: theme.values.iconSize[3],
      height: theme.values.iconSize[3],
    },
  })),
  'size:4': createIconVariant((theme) => ({
    icon: {
      width: theme.values.iconSize[4],
      height: theme.values.iconSize[4],
    },
  })),
  'size:5': createIconVariant((theme) => ({
    icon: {
      width: theme.values.iconSize[5],
      height: theme.values.iconSize[5],
    },
  })),
  chatMessage: createIconVariant(theme => ({
    icon: {
      width: theme.size['x-small'],
      height: theme.size['x-small'],
    },
  })),
  error: createIconVariant(theme => ({
    icon: {
      color: theme.baseColors.redTransparent700,
      tintColor: theme.baseColors.redTransparent700,
    },
  })),
}

StyleRegistry.registerVariants('Icon', IconStyles)
